import React from 'react';
import { gql } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { TextField, Datagrid } from 'react-admin';
import List from 'components/List';
import EnumField from 'components/Enum/EnumField';
import IdField from 'components/IdField';

const ProfessionalBlockReasonList = () => (
  <List exporter={false} filters={[<IdInput />]}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <IdField />
      <EnumField source="kind" />
      <TextField source="label" />
    </Datagrid>
  </List>
);

ProfessionalBlockReasonList.query = gql`
  query professionalBlockReasons($input: ProfessionalBlockReasonQueryInput) {
    _professionalBlockReasonsMeta(input: $input) {
      count
    }
    professionalBlockReasons(input: $input) {
      id
      kind
      label
    }
  }
`;

export default ProfessionalBlockReasonList;
